import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface User {
  name: string
  family: string
}

export interface UserResponse {
  user: User
  token: string
}

export interface LoginRequest {
  username: string
  password: string
  captcha?: string
  code?: string
}

export interface SignupRequest {
  mobile: string
  name: string
  family: string
  password: string
  rePassword: string
  captcha?: string
  code?: string
  referral_code?: string
  site_name?: string
  domain: string
  is_new_domain?: boolean
  field_id: number | null
  theme_id?: number | null
  theme_name?: string
  is_vip?: boolean
  is_consult?: boolean
  graphic?: boolean,
  pages:number,
  answers:object
}

export interface ResetRequest {
  mobile: string
  password?: string
  captcha?: string
  code?: string
}


export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['auth'],

  endpoints: (builder) => ({
    login: builder.mutation<UserResponse, LoginRequest>({
      query: (credentials) => ({
        url: 'auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    send_code: builder.mutation<UserResponse, SignupRequest>({
      query: (credentials) => ({
        url: 'auth/signup/send_code',
        method: 'POST',
        body: credentials,
      }),
    }),
    signup: builder.mutation<boolean, SignupRequest>({
      query: (credentials) => ({
        url: 'auth/signup',
        method: 'POST',
        body: credentials,
      }),
    }),
    getCaptcha: builder.query<{ text: string, data:TrustedHTML }, any>({
      query: () => 'auth/generate_captcha',
      providesTags: ['auth'],
    }),
    site_create: builder.mutation<UserResponse, SignupRequest>({
      query: (data) => ({
        url: 'site/create',
        method: 'POST',
        body: data,
      }),
    }),
    survey_create: builder.mutation<UserResponse, SignupRequest>({
      query: (data) => ({
        url: 'survey',
        method: 'POST',
        body: data,
      }),
    }),
    signupـcomplete: builder.mutation<UserResponse, SignupRequest>({
      query: (credentials) => ({
        url: 'auth/signup/complete',
        method: 'POST',
        body: credentials,
      }),
    }),

    resetSendCode: builder.mutation<boolean, ResetRequest>({
      query: (credentials) => ({
        url: 'auth/reset_password/send_code',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetVerify: builder.mutation<UserResponse, ResetRequest>({
      query: (credentials) => ({
        url: 'auth/reset_password/verify_code',
        method: 'POST',
        body: credentials,
      }),
    }),
  }),
})

export const {useLoginMutation, useSignupMutation, useSignupـcompleteMutation, 
  useSend_codeMutation, useSite_createMutation, useSurvey_createMutation, useGetCaptchaQuery,
  useResetSendCodeMutation, useResetVerifyMutation
} = authApi
